import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../api-client';

export interface PlanData {
  id: string;
  name: string;
  includedTokens: number;
  overageRate: string;
  platformAccessFee: string;
  maxUsers: number;
}

export interface PlanInput {
  name: string;
  includedTokens: number;
  overageRate: string;
  platformAccessFee: string;
  maxUsers: number;
}

export function useCreatePlan() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: PlanInput) => {
      const res = await apiFetch('/api/console/plans', {
        method: 'POST',
        body: JSON.stringify(input),
      });
      if (!res.ok) throw new Error('Failed to create plan');
      return res.json() as Promise<PlanData>;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['plans'] }),
  });
}

export function useUpdatePlan() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...input }: PlanInput & { id: string }) => {
      const res = await apiFetch(`/api/console/plans/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(input),
      });
      if (!res.ok) throw new Error('Failed to update plan');
      return res.json() as Promise<PlanData>;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['plans'] }),
  });
}
